import { ActiveGameType, SpinGameVariant } from '@ps/web-poker-types';

import {
  TXTCLI_Cash__games,
  TXTCLI_Flash_HoldXem,
  TXTCLI_HoldXem,
  TXTCLI_HoldXem_Six,
  TXTCLI_Max_HoldXem,
  TXTCLI_Omaha,
  TXTCLI_Spin_X_Go,
  TXTCLI_Tourney
} from './utils.messages.json';

export const SAG_GAME_VARIANTS_TRANSLATIONS = {
  [SpinGameVariant.HOLDEM]: TXTCLI_HoldXem,
  [SpinGameVariant.HOLDEM_FLASH]: TXTCLI_Flash_HoldXem,
  [SpinGameVariant.HOLDEM_MAX]: TXTCLI_Max_HoldXem,
  [SpinGameVariant.HOLDEM_SIX]: TXTCLI_HoldXem_Six,
  [SpinGameVariant.OMAHA]: TXTCLI_Omaha
};

export const GAME_TYPE_TRANSLATIONS = {
  [ActiveGameType.Tourney]: TXTCLI_Tourney,
  [ActiveGameType.Cash]: TXTCLI_Cash__games,
  [ActiveGameType.SAG]: TXTCLI_Spin_X_Go
};
